export const COLUMNS = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  // {
  //   Header: 'Discount',
  //   accessor: 'discountPrecentage',
  // },
  // {
  //   Header: 'Expire',
  //   accessor: 'expireDate',
  // },
  {
    Header: 'Delete',
    accessor: '',
  },
];
